export const getAttributeFromParent = (attributes = {}, attributesParent = {}, name, defaultValue = undefined) => {
  if (attributes[name]) {
    return name === 'background-url' ? `url(${attributes[name]})` : attributes[name]
  } else if (attributesParent[name]) {
    return name === 'background-url' ? `url(${attributesParent[name]})` : attributesParent[name]
  }
  return defaultValue;
};
